module.exports = __webpack_public_path__ + "logo_transparent-6f79eeb2c38ec2d12ed4d978322457d6.png";


//////////////////
// WEBPACK FOOTER
// ./app/javascript/images/mailer/logo_transparent.png
// module id = 281
// module chunks = 86